export default function () {
    return {
        restrict: 'E',
        scope: {
            book: '=',
            addToDrive: '=addToDrive',
            onPurchaseClick: '=onPurchaseClick',
            premiumMessage: '@',
            subscription: '='
        },
        /* eslint-disable no-param-reassign */
        link: (scope) => {
            scope.getPremiumClassForAll = (data) => {
                try {
                    if (data.premium) {
                        return true;
                    }
                    return false;

                } catch (error) {
                    return false;
                }
            };

            scope.getPremiumClass = (data, subscription) => {
                if (subscription) {
                    return false;
                }
                try {
                    if (data.premium) {
                        return true;
                    }
                    return false;

                } catch (error) {
                    return false;
                }
            };
        },
        template: `<a class="overlay bundle_item_parent" ng-click="addToDrive(book);" data-toggle="tooltip" data-placement="bottom"
                            data-trigger="hover" title="{{book.name}}" >
                <img ng-src="{{book.previews[0]}}" class="bundle_item">
                <div class="premium-item" ng-if="getPremiumClass(book, subscription)" ng-click="onPurchaseClick(book)">
                    <img class="premium-image" class="col-12"
                        src="https://cdn1.drawpforschool.com/assets/3720/cdn1-372036129685461408-1623759649274860280/180x180/cdn1-372036129685461408-1623759649274860280.png" />
                    <div class="premium-text" class="col-12">{{premiumMessage}}</div>
                    <button class="mdc-button mdc-button--raised primary premium-purchase-button">
                        <span class="mdc-button__label">Purchase</span>
                    </button>
                </div>
                <div class="premium-item-footer" ng-if="getPremiumClassForAll(book)">
                    <img src="https://app.drawpforschool.com/static/img/teacher_website/drawp-144.png"
                        class="premium-footer-image" />
                    <div class="premium-footer-text">Premium</div>
                </div>
            </a>`
    };
};
